module.exports = {
        srcSet: __webpack_public_path__ + "premier_types_premier_hdi-170-44f16c17348fada3.digested.png"+" 170w",
        images: [{path: __webpack_public_path__ + "premier_types_premier_hdi-170-44f16c17348fada3.digested.png",width: 170,height: 168}],
        src: __webpack_public_path__ + "premier_types_premier_hdi-170-44f16c17348fada3.digested.png",
        toString: function(){return __webpack_public_path__ + "premier_types_premier_hdi-170-44f16c17348fada3.digested.png"},
        
        width: 170,
        height: 168
      }